import React, { useState } from 'react';
import featherStatic from '../assets/saga/feather_spin_static.png';

export interface FeatherSpinnerProps {
  className?: string;
  style?: React.CSSProperties;
  alt?: string;
  speedMs?: number; // control spin speed (default 1000ms)
}

const FeatherSpinner: React.FC<FeatherSpinnerProps> = ({
  className,
  style,
  alt = 'Loading...',
  speedMs = 1000,
}) => {
  const [loaded, setLoaded] = useState(false);

  const mergedClass = ['feather-spinner', loaded ? 'feather-spin' : '', className]
    .filter(Boolean)
    .join(' ');

  const toNumber = (v: any, d: number) => {
    if (typeof v === 'number') return v;
    if (typeof v === 'string') {
      const n = parseInt(v, 10);
      return Number.isFinite(n) ? n : d;
    }
    return d;
  };

  const fallbackW = toNumber(style?.width, 64);
  const fallbackH = toNumber(style?.height, fallbackW);

  return (
    <span
      className="feather-spin-wrap"
      role="status"
      aria-label={alt}
      style={{ ['--feather-spin-duration' as any]: `${speedMs}ms` }}
    >
      {!loaded && (
        <span className="feather-fallback" aria-hidden="false">
          <svg
            width={fallbackW}
            height={fallbackH}
            viewBox="0 0 50 50"
            focusable="false"
          >
            <g>
              <circle
                cx="25"
                cy="25"
                r="20"
                stroke="var(--text-secondary, #475569)"
                strokeWidth="4"
                fill="none"
                strokeLinecap="round"
                strokeDasharray="31.4 31.4"
              />
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 25 25"
                to="360 25 25"
                dur={`${speedMs}ms`}
                repeatCount="indefinite"
              />
            </g>
          </svg>
        </span>
      )}

      <img
        src={featherStatic}
        alt={alt}
        className={mergedClass}
        decoding="async"
        draggable={false}
        style={{ ...style, visibility: loaded ? 'visible' : 'hidden' }}
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(false)}
      />
    </span>
  );
};

export default FeatherSpinner;
